/* ===================================================================
   ROUGE トピックス
   ブログ記事（TOPICS）の本文に置いた

     <div class="rouge-topic__product" data-product-handle="商品のURL名"></div>

   を見つけて、Shopifyから商品情報を取ってきて中身を組み立てる。

   ─ なぜJavaScriptなのか ─
   Shopifyのブログ記事の本文ではLiquidが動かないため、
   {{ product.title }} のような書き方ができない。
   そこで記事には「商品のURL名（ハンドル）」だけを書いておき、
   商品名・画像・リンクはShopifyの商品データ（/products/ハンドル.js）から
   取得する。こうすると商品名や画像を変更しても記事側は直さなくてよい。

   ─ 取得している情報 ─
     title            … 商品名
     url              … 商品ページへのリンク
     images           … 登録画像すべて（1枚目をメイン、全部をサムネイルに使う）
     available        … 在庫があるか（無ければ buy now を sold out にする）
     price            … 販売価格             ★2025-09-09 追加
     compare_at_price … セール前の価格         ★2025-09-09 追加
     options          … カラー・サイズなどの選択肢 ★2025-09-09 追加

   ─ 2025-09-09 の変更 ─
   価格とカラー／サイズを表示するようにした。
   これらのデータは以前から /products/ハンドル.js に含まれていて、
   画面に出していなかっただけ。商品の取得方法は変えていない。

   並び順は「商品名 → 価格 → カラー/サイズ → サムネイル → buy now」。
   =================================================================== */

(function () {
  'use strict';

  /* Shopifyの画像URLに幅を指定する。
     元のURLに ?v=... が付いていることがあるので、
     ? が既にあるかどうかで & と ? を使い分ける。 */
  function sized(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  /* 商品名をHTMLに埋め込む前に無害化する。
     商品名に < や " が入っていてもレイアウトが壊れないようにするため。 */
  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[char];
    });
  }

  /* 価格を「¥16,500」の形にする。

     ★Shopifyが返す価格は「100倍された整数」★
     実測：¥16,500 の商品 → 1650000 が返ってくる。
     そのため100で割ってから3桁区切りにしている。

     ※このストアは日本円のみなので、この計算で問題ない。
       将来ドルなど小数のある通貨を扱う場合は、
       小数点以下の処理を足す必要がある。 */
  function yen(amount) {
    return '¥' + Math.round(amount / 100).toLocaleString('ja-JP');
  }

  /* 価格の表示を組み立てる。
     セール中（compare_at_price が販売価格より高い）のときだけ、
     セール前の価格に取り消し線を付けて左に並べる。
     セールでない商品は compare_at_price が null なので何も出ない。 */
  function buildPrice(product) {
    if (typeof product.price !== 'number') return '';

    var isSale =
      typeof product.compare_at_price === 'number' &&
      product.compare_at_price > product.price;

    return (
      '<p class="rouge-topic__price' + (isSale ? ' rouge-topic__price--sale' : '') + '">' +
      (isSale
        ? '<span class="rouge-topic__price-compare">' + yen(product.compare_at_price) + '</span>'
        : '') +
      '<span class="rouge-topic__price-now">' + yen(product.price) + '</span>' +
      '<span class="rouge-topic__price-tax">税込</span>' +
      '</p>'
    );
  }

  /* カラー・サイズなどの選択肢を「color：RED / BLGR」の形にする。

     ★選択肢が無い商品への対応★
     色もサイズも登録していない商品は、Shopifyが自動で
     「Title ＝ Default Title」という中身のない選択肢を作る。
     実測でも6商品中2商品がこれだった。
     そのまま出すと「Title：Default Title」と表示されてしまうので除外する。

     選択肢の名前（color / Color / サイズ など）は商品管理の
     登録どおりに表示している。表記をそろえたい場合は、
     このコードではなくShopifyの商品管理側で直すのが正しい。

     options は新しい形式 [{name, values}] で返るが、
     古い形式 ['Color'] のストアでも落ちないようにしてある。 */
  function buildOptions(product) {
    var options = product.options || [];
    var rows = [];

    options.forEach(function (option) {
      var name = option && option.name ? option.name : option;
      var values = option && option.values ? option.values : [];

      if (!name) return;
      if (String(name).toLowerCase() === 'title') return;
      if (!values.length) return;
      if (values.length === 1 && values[0] === 'Default Title') return;

      rows.push(
        '<span class="rouge-topic__option-name">' + escapeHtml(name) + '</span>：' +
        values
          .map(function (value) {
            return escapeHtml(value);
          })
          .join(' / ')
      );
    });

    if (!rows.length) return '';
    return '<p class="rouge-topic__options">' + rows.join('<br>') + '</p>';
  }

  function render(el, product) {
    var images = product.images && product.images.length ? product.images : [product.featured_image];
    var mainSrc = images[0];
    var name = escapeHtml(product.title);
    var url = product.url;

    /* サムネイルは画像が2枚以上あるときだけ出す。
       1枚しかない商品でメイン画像と同じものが並ぶのを避ける。 */
    var thumbsHtml = '';
    if (images.length > 1) {
      var items = images
        .map(function (src, index) {
          return (
            '<button type="button" class="rouge-topic__thumb' +
            (index === 0 ? ' is-active' : '') +
            '" data-full="' +
            sized(src, 1200) +
            '" aria-label="' +
            name +
            ' の画像' +
            (index + 1) +
            '">' +
            '<img src="' + sized(src, 300) + '" alt="" loading="lazy">' +
            '</button>'
          );
        })
        .join('');
      thumbsHtml = '<div class="rouge-topic__thumbs">' + items + '</div>';
    }

    var ctaHtml = product.available
      ? '<a class="rouge-topic__buy" href="' + url + '">buy now</a>'
      : '<span class="rouge-topic__buy rouge-topic__buy--soldout">sold out</span>';

    el.innerHTML =
      '<a class="rouge-topic__main" href="' + url + '">' +
      '<img src="' + sized(mainSrc, 1200) + '" alt="' + name + '" loading="lazy">' +
      '</a>' +
      '<p class="rouge-topic__name">' + name + '</p>' +
      buildPrice(product) +
      buildOptions(product) +
      thumbsHtml +
      '<div class="rouge-topic__cta">' + ctaHtml + '</div>';

    /* サムネイルを押したらメイン画像を差し替える。
       ページ遷移はしないので、記事を読みながら色や柄を確認できる。 */
    var mainImg = el.querySelector('.rouge-topic__main img');
    var thumbs = el.querySelectorAll('.rouge-topic__thumb');
    Array.prototype.forEach.call(thumbs, function (btn) {
      btn.addEventListener('click', function () {
        mainImg.src = btn.getAttribute('data-full');
        Array.prototype.forEach.call(thumbs, function (other) {
          other.classList.remove('is-active');
        });
        btn.classList.add('is-active');
      });
    });
  }

  function load(el) {
    var handle = el.getAttribute('data-product-handle');
    if (!handle) return;

    /* 多言語ストアでもURLが崩れないよう、Shopifyが持っているルートを使う */
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('商品が見つかりません: ' + handle);
        return response.json();
      })
      .then(function (product) {
        render(el, product);
      })
      .catch(function (error) {
        /* 商品が削除された・URL名を間違えた場合は、記事に空の枠を残さず消す。
           原因が追えるようにコンソールには内容を出しておく。 */
        console.error('[ROUGE topics] 商品を読み込めませんでした:', error);
        el.classList.add('is-error');
      });
  }

  function init() {
    var blocks = document.querySelectorAll('.rouge-topic__product[data-product-handle]');
    Array.prototype.forEach.call(blocks, load);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
